import global from './global'
import styleSelect from './styleSelect'
import utility from './utility'
import createNotification from './createNotification'

const boltIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>'
const heartIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>'
const iconClose = `<svg width="11px" height="12px" viewBox="0 0 11 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>delete</title><g id="Pop-up-|-If-you-win---Mobile" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-281.000000, -27.000000)"><g id="ICON-Close" transform="translate(274.000000, 20.000000)" fill="#FFFFFF"><path d="M17.098,16.042 C17.274,16.24 17.428,16.548 17.428,16.878 C17.428,17.472 16.944,18.154 16.152,18.154 C15.8,18.154 15.404,18.044 15.184,17.736 L12.478,14.392 L9.816,17.692 C9.552,18.044 9.2,18.154 8.848,18.154 C8.034,18.154 7.572,17.472 7.572,16.878 C7.572,16.548 7.704,16.24 7.902,16.042 L10.85,12.5 L8.1,9.354 C7.924,9.156 7.77,8.826 7.77,8.518 C7.77,7.858 8.32,7.22 9.068,7.22 C9.398,7.22 9.728,7.286 10.014,7.638 L12.5,10.608 L14.986,7.638 C15.25,7.286 15.602,7.22 15.932,7.22 C16.68,7.22 17.23,7.858 17.23,8.518 C17.23,8.826 17.076,9.156 16.9,9.354 L14.15,12.5 L17.098,16.042 Z" id="x"></path></g></g></svg>`
const iconTrash = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>`
const iconFav = `<svg width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 1)" fill-rule="nonzero" fill="none" opacity=".2"><circle stroke="#000" stroke-width=".632" cx="7.5" cy="7.5" r="7.5"/><path d="M9.765 11.14a.282.282 0 01-.133-.034L7.377 9.925l-2.25 1.181a.282.282 0 01-.408-.296l.428-2.506-1.815-1.773a.282.282 0 01.158-.482l2.514-.367 1.128-2.277a.282.282 0 01.507 0l1.128 2.277 2.514.367a.282.282 0 01.158.482L9.618 8.304l.429 2.506a.282.282 0 01-.11.282.282.282 0 01-.172.048zM7.383 9.325c.045 0 .09.01.13.03l1.877.987-.358-2.089a.282.282 0 01.081-.248l1.517-1.48-2.097-.304a.282.282 0 01-.212-.155l-.938-1.9-.94 1.9a.282.282 0 01-.21.155l-2.098.304 1.517 1.48a.282.282 0 01.081.248l-.358 2.09 1.878-.987a.282.282 0 01.13-.031z" fill="#000"/></g></svg>`
const iconReset = `<svg version="1.0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><title>reset</title><path fill="#1CA3CC" d="M16.02 29.92C7.92 30.48 1.05 24.59.07 16.9c-.13-1.01.67-1.91 1.7-1.91.86 0 1.58.65 1.69 1.5.79 6.09 6.35 10.71 12.81 9.99 5.31-.59 9.59-4.86 10.19-10.17.78-6.96-4.69-12.88-11.51-12.88-2.49 0-4.91.8-6.9 2.27l2.1 2.1c.15.15.06.4-.15.43l-7.36 1a.53.53 0 01-.6-.6L3.02.75c.02-.19.26-.27.39-.14l2.47 2.44C8.48 1.08 11.67.01 14.95.01c8.63 0 15.57 7.3 14.96 16.04-.52 7.38-6.5 13.35-13.89 13.87z"/></svg>`

const lotteryGame = {
    init: function () {
        const _this = this;
        
        // create the display for each game card
        function renderCustomGame(isSystemEntry) { 
            const playGames = [...document.querySelectorAll('.play-now--game')];
            playGames.map(playGame => {
                const gameType = playGame.dataset.game
                const gameConfig = JSON.parse(playGame.dataset.gameconfig)
                //const gameProcess = playGame.dataset.process // play, checkout, fav
                let selectedNumbers

                if (playGame.dataset.selectednumbers) {
                    selectedNumbers = JSON.parse(playGame.dataset.selectednumbers)
                }

                var selectCallback = null
                var removeCallback = null
                if (gameConfig.process === "play" && gameConfig.lotteryCode === "FBALL") {
                    selectCallback = lotteryGame.selectFutureballGameCallback
                }
                else if (gameConfig.process == "checkout") {
                    selectCallback = lotteryGame.selectCheckoutCallback
                    removeCallback = lotteryGame.removeCheckoutCallback
                }
                else if (gameConfig.process == "fav") {
                    selectCallback = lotteryGame.selectFavouritesCallback
                    removeCallback = lotteryGame.removeFavouritesCallback
                }
                new _this.buildGame(playGame, gameType, gameConfig, selectedNumbers, selectCallback, removeCallback, isSystemEntry ? isSystemEntry: false)
            });
        }

        renderCustomGame();

        //Render new game when System Entry options are changed
        const gamesSelectCustomInput = document.querySelector("select[name='SelectGameCustom']");
        if (gamesSelectCustomInput) {
            gamesSelectCustomInput.onchange = (e) => {
                const selectedIndex = gamesSelectCustomInput.selectedIndex;
                const systemEntryConfig = gamesSelectCustomInput[selectedIndex].dataset.sysentry;
                const lottoSysInfor = document.querySelector(".infor-lotto-systems");
                lottoSysInfor.innerHTML =
                    `<table>
                            <tr><th>Equivalent to</th>
                            <th>Cost per system game</th></tr>
                            <tr><td>${gamesSelectCustomInput[selectedIndex].dataset.lines} standard games</td>
                            <td>${gamesSelectCustomInput[selectedIndex].dataset.cost}</td>
                            </tr>
                        </table>`
                const form = utility.findAncestorType(e.currentTarget, "form");
                if (systemEntryConfig && systemEntryConfig.systemEntryId !== "") {
                    form.querySelector("input[name='SystemEntryId']").value = gamesSelectCustomInput.value;
                    form.dataset.gameconfig = systemEntryConfig;
                    renderCustomGame(true)
                }
            }
        }

        const switchStandardSystemsTabs = [...document.querySelectorAll('.tab-toggle-standardsystems')].map(innerTab => {
            innerTab.onclick = (event) => {
                /***
                 * If Standard (0), hide select dropdown, 
                 * if lotto systems(1) show dropdown and update text with first lotto systems game
                 * */
                let gameTab = (event.target.dataset.tab == 'play-now--standard') ? 0 : 1
                const lottoSysSelect = document.querySelector(".tab-lotto-systems");
                const displayedLabel = document.querySelector("span[data-name='SelectGameCustom']")
         
                const lottoSysInfor = document.querySelector(".infor-lotto-systems");

                if (gameTab == 0 && gamesSelectCustomInput) {
                    utility.removeClass(lottoSysSelect, 'show-options')
                    utility.removeClass(lottoSysInfor, 'show-infor')
                } else {
                    utility.addClass(lottoSysSelect, 'show-options')
                    utility.addClass(lottoSysInfor, 'show-infor')
                    displayedLabel.innerHTML = gamesSelectCustomInput[gameTab].text
                    lottoSysInfor.innerHTML =
                        `<table>
                            <tr><th>Equivalent to</th>
                            <th>Cost per system game</th></tr>
                            <tr><td>${gamesSelectCustomInput[gameTab].dataset.lines} standard games</td>
                            <td>${gamesSelectCustomInput[gameTab].dataset.cost}</td>
                            </tr>
                        </table>`
                   }

                if (gamesSelectCustomInput) {                                            
                    const systemEntryConfig = gamesSelectCustomInput[gameTab].dataset.sysentry;
                    const form = utility.findAncestorType(gamesSelectCustomInput, "form");

                    if (systemEntryConfig && systemEntryConfig.systemEntryId !== "") {
                            if(form)
                             form.querySelector("input[name='SystemEntryId']").value = gamesSelectCustomInput[gameTab].value;
                            form.dataset.gameconfig = systemEntryConfig;
                            renderCustomGame(true)
                        }
                    }                                                
                event.preventDefault();
            }
        });

        //Render new FAV game when System Entry options are changed
        const gamesSelectCustomInputFav = document.querySelector("select[name='SelectGameFav']");
        if (gamesSelectCustomInputFav) {
        // rebuild select drowpdown
        // check all forms and hide select options with form systemEntryId
            gamesSelectCustomInputFav.onchange = (e) => {
                if (e.target.selectedIndex == 0)
                    return
                lotteryGame.buildFavouriteLottery(e.currentTarget);     
            }
        }

        // lotteries in the favourite lottery selector in the account section
        lotteryGame.buildFavouriteLotterySelector();

        // expands/collapses games on the checkout page
        const expandGames = [...document.querySelectorAll('.number-lines-expand')];
        expandGames.map(expand => {
            const expandText = expand.innerHTML
            const expandLessText = expand.dataset.subtext

            expand.onclick = () => {
                const expandNumberLines = expand.parentNode.querySelector('.game-number-lines')
                expandNumberLines.classList.toggle('number-lines-minimised')
                // expand.parentNode.removeChild(expand)

                if(expandLessText) {
                    if(expandNumberLines.classList.contains('number-lines-minimised')) {
                        expand.innerHTML = expandText
                    } else {
                        expand.innerHTML = expandLessText
                    }
                }
            }
        });

        // favourites buttons
        [...document.querySelectorAll(".lottery-card-favourite")].map(form => {
            form.onsubmit = (e) => {
                lotteryGame.requestFavouritesPlay(e.target);
                return false;
            };
            form.querySelector(".card-trash").onclick = (e) => {
                const systemEntryId = e.currentTarget.dataset.systementryid;
                const form = utility.findAncestor(e.currentTarget, "lottery-card-favourite");
                lotteryGame.deleteFavouriteLottery(systemEntryId, form);
            };
        });

        // custom play form
        const customPlayForm = document.getElementById("play-now--custom-form");
        if (customPlayForm) {
            customPlayForm.onsubmit = (e) => {
                const button = e.target.querySelector("button[type=submit]");
                utility.disableButton(button);
                lotteryGame.submitGames(e.target, button);
                return false;
            };
        }

        const accountFavSelector = document.getElementById("account-favourites-selector");
        if (accountFavSelector) {
            accountFavSelector.onchange = (e) => {
                if (e.target.value) {
                    window.location.href = e.target.value;
                }
            };
        }
    },

    buildFavouriteLotterySelector: function() {
        const container = document.getElementById("account--favourites-selector");
        if (!container) {
            return;
        }
        const systemEntryData = document.querySelectorAll("#account--favourites-lottery-data span");
        const selectedLotteries = document.querySelectorAll(".favourites-container input[name='systemEntryId']");
        var selector = "<select class='select-white select-add-lottery'><option value=''>Select Lottery</option>";
        for (var i = 0; i < systemEntryData.length; i++) {
            var systemEntry = systemEntryData[i];
            var existingFavourite = false;
            for (var n = 0; n < selectedLotteries.length; n++) {
                if (systemEntry.dataset.systementryid === selectedLotteries[n].value) {
                    existingFavourite = true;
                }
            }
            if (!existingFavourite) {
                selector += `<option value='${systemEntry.dataset.systementryid}' data-title='${systemEntry.dataset.lottery}' data-image='${systemEntry.dataset.image}' data-gameconfig='${systemEntry.dataset.gameconfig}'>${systemEntry.dataset.lottery}</option>`;
            }
        }
        selector += "</select>";
        container.innerHTML = selector;
        /*
        the first time this called will be on page load. The select styler will automatically style this after 
        all scripts have been run, so we only need to call the styler on subsequent updates
        */
        if (!container.dataset.initialised) {
            container.dataset.initialised = "1";
        }
        else {
            styleSelect.init("#account--favourites-selector select");
        }
        document.querySelector("#account--favourites-selector select").onchange = (e) => {
            lotteryGame.buildFavouriteLottery(e.currentTarget);
            lotteryGame.buildFavouriteLotterySelector();
        };
    },

    buildFavouriteLottery: function (selectAddFavourite) {
        const selectedOption = selectAddFavourite.options[selectAddFavourite.selectedIndex]
        const systemEntryId = selectAddFavourite.value
        const title = selectedOption.dataset.title
        const image = selectedOption.dataset.image
        const lotteryDrawId = selectedOption.dataset.lotterydrawid ? selectedOption.dataset.lotterydrawid : 0
        const gameConfig = selectedOption.dataset.gameconfig
        const gameConfigJson = JSON.parse(gameConfig)
        const newFavourite = document.createElement('form')
        const isPrimitiva = gameConfigJson.lotteryCode == 'PRIM' ? true : false;
        let reintegroOptions =""
        newFavourite.setAttribute('action', '/api/web/account/play-saved-games')
        newFavourite.setAttribute('method', 'post')
        newFavourite.classList.add('lottery-card')
        newFavourite.classList.add('lottery-card-account')
        newFavourite.classList.add('lottery-card-favourite')
        //additional html for reintegro
        if (isPrimitiva) {            
            reintegroOptions = `
                <div class="lottery-card lottery-card--grey lottery-card-flip lottery-card-flip-reintegro ">
                <div class="flipper">
                    <div class="lottery-card-front">
                        <p class="orange">Choose a Reintegro number</p>
                        <div class="custom-numbers--primitiva-lucky" data-gametype="lucky">
                            <div class="radio-container draw-multipliers draw-reintegro">
                                <label>
                                    <input type="radio" name="Reintegro" value="0">
                                    <span class="checkbox"></span><span>0</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="1">
                                    <span class="checkbox"></span><span>1</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="2">
                                    <span class="checkbox"></span><span>2</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="3">
                                    <span class="checkbox"></span><span>3</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="4">
                                    <span class="checkbox"></span><span>4</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="5">
                                    <span class="checkbox"></span><span>5</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="6">
                                    <span class="checkbox"></span><span>6</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="7">
                                    <span class="checkbox"></span><span>7</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="8">
                                    <span class="checkbox"></span><span>8</span>
                                </label>
                                <label>
                                    <input type="radio" name="Reintegro" value="9">
                                    <span class="checkbox"></span><span>9</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="lottery-card-back lottery-card-back--spacing">
                        <p>Choose a Reintegro number for each ticket. Each ticket can have up to 8 games.</p>
                    </div>
                </div>
            </div> `
        }

        newFavourite.innerHTML = `
            <input type="hidden" name="systemEntryId" value="${systemEntryId}" />
            <input type="hidden" name="sourceId" value="FAV" />
            <input type="hidden" name="lotteryDrawId" value="${lotteryDrawId}" />
            <span class='card-trash' data-systementryid="${systemEntryId}">${iconTrash}</span>
            <div class="favourite-lottery play-now--game" data-gameconfig='${gameConfig}'>
                <div class="favourite-header"><img class="lottery-flag flag-round" src="${image}" alt="${title}" width="30" height="30">
                    <h4>${title}</h4>
                </div>
                <div class="game-number-lines no-favourite"></div>
                <p class="add-game button button-orange active">Add favourite</p>  
                ${reintegroOptions}
                <button type="submit" class="button button-green-solid">Play favourites</button>
            </div>`

        document.querySelector('.favourites-container').appendChild(newFavourite)
        newFavourite.onsubmit = (e) => {
            lotteryGame.requestFavouritesPlay(e.target);
            return false;
        };
        newFavourite.querySelector(".card-trash").onclick = (e) => {
            const systemEntryId = e.currentTarget.dataset.systementryid;
            const form = utility.findAncestor(e.currentTarget, "lottery-card-favourite");
            lotteryGame.deleteFavouriteLottery(systemEntryId, form);
        };
        window.scrollBy({ top: -100, left: 0, behavior: 'smooth' })

        new lotteryGame.buildGame(newFavourite.querySelector('.play-now--game'), 'custom', gameConfigJson, null, lotteryGame.selectFavouritesCallback, lotteryGame.removeFavouritesCallback)
    },

    requestFavouritesPlay: function(favouritesForm) {
        const ajaxOptions = {
            url: "/api/web/account/play-account-saved-lottery",
            method: "POST",
            data: utility.getFormData(favouritesForm),
            success: function (e) {
                utility.showNotificationPopup({
                    title: "Success",
                    content: e.target.responseText
                });
                global.updateCartSummary();
            },
            always: function() {
                utility.enableButton(favouritesForm.querySelector("button[type=submit]"));
            }
        };
        utility.disableButton(favouritesForm.querySelector("button[type=submit]"));
        utility.ajaxRequest(ajaxOptions);
    },

    submitGames: function(form, button) {
        const ajaxOptions = {
            url: "/api/web/lottery/custom-play",
            method: "POST",
            data: utility.getFormData(form),
            success: function(e) {
                var result = JSON.parse(e.target.responseText);
                if (result.result == "R") {
                    window.location.href = result.location;
                }
                else if (result.result == "L") {
                    utility.enableButton(button);
                    utility.showLoginPopup();
                }
                else {
                    utility.enableButton(button);
                    let errorMessage = result.result == "E" ? result.message : "An unknown error has occurred";
                    utility.showNotificationPopup({
                        title: "Error",
                        content: errorMessage
                    });
                }
            },
            error: function(e) {
                utility.enableButton(button);
            }
        };
        utility.ajaxRequest(ajaxOptions);
    },

    // callbacks for adding/removing games in cart or favourites
    selectCheckoutCallback: function (gameLine) {
        const ajaxOptions = {
            url: "/api/web/checkout/update-game",
            method: "POST",
            data: "gameId=" + gameLine.selectedNumbers.id + "&numbers=" + JSON.stringify(gameLine.selectedNumbers),
            success: function(e) {
                window.location.reload(true);
            },
        };
        utility.ajaxRequest(ajaxOptions);
        return true;
    },

    removeCheckoutCallback: function (gameLine) {
        const ajaxOptions = {
            url: "/api/web/checkout/delete-game",
            method: "POST",
            data: "gameId=" + gameLine.selectedNumbers.id,
            success: function(e) {
                window.location.reload(true);
            },
        };
        utility.ajaxRequest(ajaxOptions);
        return true;
    },

    selectFavouritesCallback: function (gameLine) {
        if (gameLine.isPrimitiva && gameLine.selectedNumbers.supp && gameLine.selectedNumbers.supp.length === 1) {
            gameLine.selectedNumbers.supp[0] = 0;
        }
        const ajaxOptions = {
            url: "/api/web/account/add-saved-game",
            method: "POST",
            data: "systemEntryId=" + gameLine.gameConfig.systemEntryId + "&id=" + gameLine.selectedNumbers.id + "&numbers=" + JSON.stringify(gameLine.selectedNumbers),
            success: function(e) {
                var result = JSON.parse(e.target.responseText)
                if (result.id === 0) {
                    // error
                }
                else if (result.id < 0) {
                    gameLine.removeGameLine();
                }
                else {
                    gameLine.selectedNumbers.id = result.id
                    gameLine.updateFormData()
                }
            },
        };
        utility.ajaxRequest(ajaxOptions);
        return false;
    },

    removeFavouritesCallback: function (gameLine) {
        const ajaxOptions = {
            url: "/api/web/account/delete-saved-game",
            method: "POST",
            data: "id=" + gameLine.selectedNumbers.id
        };
        utility.ajaxRequest(ajaxOptions);
        return false;
    },

    deleteFavouriteLottery: function(systemEntryId, form) {
        const ajaxOptions = {
            url: "/api/web/account/delete-saved-lottery",
            method: "POST",
            responseType: "text",
            data: "systemEntryId=" + systemEntryId,
            success: function(e) {
                form.parentNode.removeChild(form);
                lotteryGame.buildFavouriteLotterySelector();
            },
        };
        utility.ajaxRequest(ajaxOptions);
    },

    selectFutureballGameCallback: function (gameLine) {
        const lotteryDrawId = 0;
        const systemEntryId = gameLine.gameConfig.systemEntryId;
        const numbers = JSON.stringify(gameLine.selectedNumbers);
        const postData = `lotteryDrawId=${lotteryDrawId}&systemEntryId=${systemEntryId}&numbers=${numbers}`;
        const ajaxOptions = {
            url: "/api/web/lottery/ls/check-custom-numbers",
            method: "POST",
            data: postData,
            success: function (e) {
                console.log(e.target.responseText);
                let data = JSON.parse(e.target.responseText);
                if (data && data.length === 1) {
                    var game = data[0];
                    if (game.Status !== 0) {
                        createNotification(game.StatusDescription);
                    }
                }
            },
        };
        utility.ajaxRequest(ajaxOptions);
        return false;
    },

    buildGame: class {
        constructor(playGame, gameType, gameConfig, selectedNumbers, selectCallback, removeCallback, systemEntry) {
            this.gameCost = this.gameCost.bind(this)
            this.playGame = playGame
            this.gameType = gameType
            this.gameConfig = gameConfig
            this.selectedNumbers = selectedNumbers
            this.totalCostContainer = this.playGame.querySelector('.total-cost')
            this.selectCallback = selectCallback
            this.removeCallback = removeCallback
            this.systemEntry = systemEntry
            this.numberLines = playGame.querySelector('.game-number-lines')
            this.linesCount = [...this.numberLines.querySelectorAll('.game-number-line')].length + 1
            this.submitButton = playGame.querySelector('*[type="submit"]')
            this.isPrimitiva = this.gameConfig.lotteryCode == 'PRIM' ? true : false;
            this.isFutureball = this.gameConfig.lotteryCode === 'FBALL';
            this.handleButtonClick()
            this.handleSubmit()          
            if (this.selectedNumbers != undefined) {
                this.selectedNumbers.map(selectedNumber => {
                    this.addGame(1, 'selected', selectedNumber)
                })
            }

            if (this.gameType == 'custom' && this.linesCount == 1 && !this.systemEntry) {
                this.addGame(1)
            }

            if (this.systemEntry) {
                this.resetGameSettings()
                this.addGame(1)
            }

            if (this.gameType != undefined) {
                this.choosePlays();
                this.handlePlusGame();
                this.handleMultiDraw();
            }
                // this.setReintegroNumber()
        }

        handleButtonClick() {
            this.addGameButton = this.playGame.querySelector('.add-game')
            if(this.addGameButton == undefined)
                return

            this.addGameButton.onclick = () => {
                if (this.addGameButton.classList.contains('disabled')) {
                    window.scrollBy({top: this.numberLines.querySelector('.game-numbers--container').parentNode.getBoundingClientRect().top - document.querySelector('#header').offsetHeight - 10, left: 0, behavior: 'smooth' })
                    createNotification('Please complete started game before adding another one.')
                    return
                }
                this.addGame(1)
            }
        }

        handleSubmit() {
            if (this.submitButton) {
                this.submitButton.onclick = (e) => {
                    let activeSelect = this.playGame.querySelector('.select-numbers')

                    //Check for Reintegro if Primitva
                    if (this.isPrimitiva) {
                        let reintegroChosen = this.playGame.querySelector("input[name='Reintegro']:checked")
                        if (!reintegroChosen) {
                            createNotification("Please select a Reintegro number.")
                            e.preventDefault()
                        } else {
                            //set Reintegro to all games pn Play Now
                            this.setReintegroNumber(reintegroChosen.value);
                        }

                    }

                    if (activeSelect) {
                        activeSelect.click()
                        activeSelect = this.playGame.querySelector('.select-numbers')

                        if (activeSelect) {
                            e.preventDefault()
                        }
                    }
                }
            }
        }

        choosePlays() {
            const choosePlays = [...this.playGame.querySelectorAll('.choose-plays-container input')]

            choosePlays.map(choosePlay => {
                if (choosePlay.type == 'radio') {
                    choosePlay.onchange = () => {
                        this.linesCount = 1
                        const customInput = this.playGame.querySelector('.choose-plays-container input[type="number"]')
                        
                        if(customInput != null) {
                            customInput.value = ''
                        }

                        this.addGame(choosePlay.value)
                    }
                } 
                else {
                    choosePlay.onkeydown = (e) => {
                        if (e.shiftKey) {
                            return false;               
                        }
                        const isValidChar = 
                            // numpad 0-9
                            (e.keyCode > 95 && e.keyCode < 106) || 
                            // keyboard 0-9
                            (e.keyCode > 47 && e.keyCode < 58) || 
                            // pgup/pgdown/home/end/arrows
                            (e.keyCode > 32 && e.keyCode < 41) ||
                            // backspace/delete/tab/escape
                            (e.keyCode == 8 || e.keyCode == 46 || e.keyCode == 9 || e.keyCode == 27);
                        return isValidChar;
                    }
                    choosePlay.oninput = () => {
                        this.linesCount = 1
                        const checkedRadio = this.playGame.querySelector('.choose-plays-container input[type="radio"]:checked')
                        if(checkedRadio != null && checkedRadio.checked) {
                            checkedRadio.checked = false
                        }
                        if (choosePlay.value.length > 2) {
                            choosePlay.value = choosePlay.value.slice(0,2)
                            return
                        }
                        this.numberLines.innerHTML = ''
                        this.addGame(choosePlay.value)
                    }
                }
            })
        }

        addGame(gamesQty, gameType = this.gameType, selectedNumbers) {     
            if(gamesQty != 1 && gameType != 'favourite') {
                this.numberLines.innerHTML = ''
            }

            if(gameType === 'favourite') {
                window.scrollBy({
                    top: this.numberLines.getBoundingClientRect().bottom - document.querySelector('#header').offsetHeight - 10, 
                    left: 0, 
                    behavior: 'smooth' 
                })
            }

            for (var i = 0; i < gamesQty; i++) {
                new lotteryGame.gameLine({
                    numberLines: this.numberLines,  
                    playGame: this.playGame, 
                    gameType: gameType ? gameType : 'custom',
                    gameConfig: this.gameConfig,
                    linesCount: this.linesCount,
                    addGameButton: this.addGameButton,
                    gameCost: this.gameCost,
                    selectedNumbers: selectedNumbers && selectedNumbers.length > 1 ? selectedNumbers[i] : selectedNumbers,
                    favouriteGame: gameType === 'favourite' ? true : false,
                    selectCallback: this.selectCallback,
                    removeCallback: this.removeCallback,
                    isPrimitiva: this.isPrimitiva,
                    isFutureball: this.isFutureball
                })
            }
        }

        handlePlusGame() {
            [...this.playGame.querySelectorAll("input[name='Multiplier'], input[name='Extra']")].map(option => {
                option.onchange = () => {
                    this.gameCost();
                }
            });
        }

        handleMultiDraw() {
            const multiDraws = [...this.playGame.querySelectorAll('.draw-multipliers input')]
            multiDraws.map(multiDraw => {
                multiDraw.onchange = e => {
                    this.gameCost()
                }
            })
        }

        setReintegroNumber(reintegroChosen) {
            if (reintegroChosen) {
                const allDraws = [...this.playGame.querySelectorAll("input[name='gameData']")]
                allDraws.map(draw => {
                    let drawGame = JSON.parse(draw.value)
                    drawGame.supp = [parseInt(reintegroChosen)]
                    draw.value = JSON.stringify(drawGame)
                })
            } 
        }

        gameCost() {
            const gameLines = this.playGame.querySelectorAll('.number-line--numbers').length;
            if (!gameLines && this.playFavouritesButton != undefined) {
                this.playFavouritesButton.classList.remove('disabled');
            }
            var costContainer = this.totalCostContainer;
            if (!costContainer) {
                return;
            }
            var button = document.querySelector("#play-now--custom-form button[type=submit]");

            const multiDrawOption = this.playGame.querySelector("input[name='NumDraws']:checked");
            const mutliplierOption = this.playGame.querySelector("input[name='Multiplier']:checked");
            const extraOption = this.playGame.querySelector("input[name='Extra']:checked");
            const numGames = gameLines;
            const numDraws = multiDrawOption ? multiDrawOption.value : 1;
            const multiplier = mutliplierOption && mutliplierOption.value === "True" ? 1 : 0;
            const extra = extraOption && extraOption.value === "True" ? 1 : 0;
            const ajaxUrl = `/api/web/lottery/calculate-entry-price?systemEntryId=${this.gameConfig.systemEntryId}&numGames=${numGames}&numDraws=${numDraws}&multiplier=${multiplier}&extra=${extra}`;
            const addGameBtn = this.playGame.querySelector('.add-game');
            const numDrawsList = [...this.playGame.querySelectorAll('.draw-multipliers input[name ="NumDraws"]')];

            function reEvaluateGameOptions(currenTotal) {
                //Add Games
                currenTotal >= 3000 ? addGameBtn.classList.add('over-limit') : addGameBtn.classList.remove('over-limit');               
                //num draws                  
                numDrawsList.map(numDraws => {
                    const cprice = currenTotal / multiDrawOption.value;
                    numDraws.value * cprice > 3000 ? numDraws.parentElement.classList.add('over-limit') : numDraws.parentElement.classList.remove('over-limit');                    
                })
            }

            utility.disableButton(button);
            utility.ajaxRequest({
                url: ajaxUrl,
                method: "GET",
                success: function (e) {
                    reEvaluateGameOptions(JSON.parse(e.target.responseText).price)
                    costContainer.innerHTML = JSON.parse(e.target.responseText).priceFormatted;
                    const totalCost = document.querySelector("#play-now--custom-play input[name='TotalCost']");
                    if (totalCost) {
                        totalCost.value = JSON.parse(e.target.responseText).price;
                    }
                },
                always: function () {
                   utility.enableButton(button);
                }
            });
        }

        resetGameSettings() {
            //remove any game dom
            this.numberLines.innerHTML = ''

            //reset multiplier, multidraw, extras           
            const multiDrawOption = this.playGame.querySelector("input[name='NumDraws'][value='1']");
            const mutliplierOption = this.playGame.querySelector("input[name='Multiplier'][value='False']");
            multiDrawOption && (multiDrawOption.checked = true);
            mutliplierOption && (mutliplierOption.checked = true);
  
            //TODO reintegro? favorites?

            //reset game cost
            this.gameCost()
        }
    },

    gameLine: class {
        constructor(props) {
            this.numberLines = props.numberLines
            this.numberLine = props.numberLine

            if (!this.numberLine) {
                this.numberLine = document.createElement('div')
                this.numberLines.appendChild(this.numberLine)
                this.numberLine.classList.add('game-number-line')
            }

            this.gameConfig = props.gameConfig
            this.gameType = props.gameType
            this.addGameButton = props.addGameButton
            this.gameCost = props.gameCost
            this.selectedNumbers = props.selectedNumbers
            this.favouriteGame = props.favouriteGame
            this.selectCallback = props.selectCallback
            this.removeCallback = props.removeCallback
            this.isPrimitiva = props.isPrimitiva
            this.isFutureball = props.isFutureball

            if (this.selectedNumbers == undefined) {
                this.selectedNumbers = {}
                this.createNumbersArr()
            }

            if (this.gameType == 'quick') {
                this.createQuickPlay()
            } else if (this.gameType == 'custom') {
                this.createCustomPlay()
            } else {
                this.createQuickPlay(false)
            }
        }

        createNumbersArr() {
            this.selectedNumbers.id = 0
            this.selectedNumbers.main = [...Array(this.gameConfig.numMain)]
            this.selectedNumbers.supp = [...Array(this.gameConfig.numSupp)]
            this.selectedNumbers.save = 0
        }

        configureRemoveGameEvent() {
            let removeLine = this.numberLine.querySelector('.remove-line');
            if (!removeLine) {
                return;
            }
            removeLine.onclick = () => {
                if (this.removeCallback) {
                    // if removeCallback returns true, it means the page will be reloaded, therefore don't perform any further animations
                    if (this.removeCallback(this)) {
                        return
                    }
                }

                this.numberLine.classList.remove('added')
                setTimeout(() => {
                    this.removeGameLine();
                }, 250)
            }
        }

        removeGameLine() {
            if (this.numberLine.parentNode == null) { 
                return;
            }
            this.numberLine.parentNode.removeChild(this.numberLine);
            this.updateLinesCount();
            this.adjustLineNumbers();
            if (this.gameCost) {
                this.gameCost();
            }
            const openGame = this.numberLines.querySelector('.game-numbers--container');
            if (this.addGameButton && !openGame) {
                this.addGameButton.classList.remove('disabled');
            }
        }

        disableButtonsOnEditMode(btnClass) {
            [...document.querySelectorAll(btnClass)].map(btnMap => {
                btnMap.classList.add('disabled')
            })
        }

        updateFormData() {
            this.numberLine.querySelector('input[name=gameData]').value = JSON.stringify(this.selectedNumbers)
        }

        editGame() {
            [...this.numberLine.querySelectorAll('.edit-line')].map(editLine => editLine.onclick = () => {
                const openGame = this.numberLines.querySelector('.game-numbers--container')
                if(openGame) {
                    createNotification('Please complete started game before proceeding.')
                    this.scrollToGame(openGame.parentNode)
                    return
                }

                if(this.addGameButton != undefined) {
                    this.addGameButton.classList.add('disabled')
                }

                //disable multiplier buttons while game is on edit mode
                this.disableButtonsOnEditMode('.add-multi')
                this.disableButtonsOnEditMode('.remove-multi')
                this.disableButtonsOnEditMode('.add-joker')
                this.disableButtonsOnEditMode('.remove-joker')

                this.createCustomPlay()
            })
        }

        quickSelect() {
            this.quickSelectButton = this.numberLine.querySelector('.quick-select')
            this.quickSelectButton.onclick = () => {
                if (this.gameConfig.process === "play" && this.isFutureball) {
                    this.quickSelectFutureballLottery()
                }
                else {
                    this.quickSelectLotteryGames()
                }
            }
        }

        quickSelectFutureballLottery() {
            const thisInstance = this;
            const lotteryDrawId = 0;
            const systemEntryId = this.gameConfig.systemEntryId;
            const numGames = 1;
            const postData = `LotteryDrawId=${lotteryDrawId}&SystemEntryId=${systemEntryId}&NumGames=${numGames}`;
            const ajaxOptions = {
                url: "/api/web/lottery/ls/get-random-numbers",
                method: "POST",
                data: postData,
                success: function (e) {
                    try {
                        console.log(e.target.responseText);
                        let data = JSON.parse(e.target.responseText);
                        thisInstance.handleQuickSelectFutureballResponse(data[0].Main, data[0].Supp);
                    }
                    catch (error) {
                        thisInstance.quickSelectLotteryGames();
                    }
                },
                error: function (e) {
                    thisInstance.quickSelectLotteryGames();
                }
            };
            utility.ajaxRequest(ajaxOptions);
        }

        handleQuickSelectFutureballResponse(mainString, suppString) {
            let mainList = Array.from(this.numberLine.querySelectorAll('.custom-numbers[data-gametype="number"] .custom-selection'));
            let suppList = Array.from(this.numberLine.querySelectorAll('.custom-numbers[data-gametype="lucky"] .custom-selection'));

            let mainSelected = mainString.split(' ').map(number => mainList.find(line => line.dataset.number === number));
            let suppSelected = suppString.split(' ').map(number => suppList.find(line => line.dataset.number === number));

            this.quickSelectLotteryGames(mainSelected, suppSelected);
        }

        quickSelectLotteryGames(mainSelected, luckySelected) {
            this.luckySelectLock = false

            var tempNumbers = this.selectedNumbers.main

            if (this.gameConfig.numSupp > 0) {
                tempNumbers = tempNumbers.concat(this.selectedNumbers.supp)
            }
            const shuffleLock = tempNumbers.indexOf(undefined) > -1

            if (this.quickSelectLock) {
                return
            }

            const useSelectedParameters = mainSelected && mainSelected.length === this.gameConfig.numMain && luckySelected && luckySelected.length === this.gameConfig.numSupp;

            [...this.numberLine.querySelectorAll('.custom-numbers')].map(customNumbers => {
                this.quickSelectLock = true
                const containerType = customNumbers.dataset.gametype

                // the count of numbers we still need to select
                let notSelectedLength = [...customNumbers.querySelectorAll('.custom-selected:not(.selected)')].length

                // the numbers that are already selected
                const selectedNumbers = [...customNumbers.querySelectorAll('.custom-selection.selected')]

                let time = 0

                // reset the selection if we've already selected everything or we're overriding with the input parameters
                if (useSelectedParameters || notSelectedLength == 0 && !this.luckySelectLock && !shuffleLock) {
                    this.quickSelectLock = true

                    if (containerType == 'number') {
                        this.selectedNumbers.main.map((emptySelected, index) => {
                            this.selectedNumbers.main[index] = undefined
                        })
                    }
                    if (containerType == 'lucky') {
                        this.selectedNumbers.supp.map((emptySelected, index) => {
                            this.selectedNumbers.supp[index] = undefined
                        })
                    }

                    selectedNumbers.map(selectedNumber => {
                        selectedNumber.classList.remove('selected')
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"]`).classList.remove('selected')
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"] span`).innerHTML = ''
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"]`).dataset.number = ''
                    })

                    notSelectedLength = [...customNumbers.querySelectorAll('.custom-selected:not(.selected)')].length
                }
                else {
                    this.luckySelectLock = true
                }

                // selects random numbers that aren't already selected, or uses the input if configured
                var notSelectedNumbers;
                if (useSelectedParameters && containerType == 'number') {
                    notSelectedNumbers = mainSelected;
                }
                else if (useSelectedParameters && containerType == 'lucky') {
                    notSelectedNumbers = luckySelected;
                }
                else {
                    notSelectedNumbers = this.shuffleArray([...customNumbers.querySelectorAll('.custom-selection:not(.selected)')], notSelectedLength);
                }

                // sets the remaining numbers to select as selected
                notSelectedNumbers.map((notSelectedNumber, index) => {
                    setTimeout(() => {
                        const allSelected = [...customNumbers.querySelectorAll('.custom-selected')]
                        const emptySelected = customNumbers.querySelector(`.custom-selected[data-number=""]`)

                        notSelectedNumber.classList.add('selected')
                        emptySelected.classList.add('selected')

                        if (containerType == 'number') {
                            this.selectedNumbers.main[allSelected.indexOf(emptySelected)] = parseInt(notSelectedNumber.dataset.number)
                        }
                        if (containerType == 'lucky') {
                            this.selectedNumbers.supp[allSelected.indexOf(emptySelected)] = parseInt(notSelectedNumber.dataset.number)
                        }

                        customNumbers.querySelector(`.custom-selected[data-number=""] span`).innerHTML = notSelectedNumber.dataset.number
                        emptySelected.dataset.number = notSelectedNumber.dataset.number

                        if (![...this.numberLine.querySelectorAll('.custom-selected:not(.selected)')].length) {
                            setTimeout(() => {
                                this.quickSelectLock = false
                            }, 150)
                        }
                    }, time)

                    time += 100
                })
            })
        }

        updateLinesCount() {
            this.linesCount = [...this.numberLines.querySelectorAll('.game-number-line')].indexOf(this.numberLine) + 1
        }

        createQuickPlay(shuffle = true) {
            this.lineHTML(shuffle)

            setTimeout(() => {
                this.numberLine.classList.add('added')
            }, 10)
        }

        createCustomPlay() {
            this.numberLine.innerHTML = this.customPlayHTML()
            this.customNumberSelection()
            this.configureRemoveGameEvent()
            this.quickSelect()

            setTimeout(() => {
                this.numberLine.classList.add('added')
            }, 10)
        }

        customPlayHTMLBlock(numbers, minNum, maxNum, count, type) {
            const customSelected = numbers.map(selectedNumber => {
                return `<p class='custom-selected custom-selected-${count} lottery-number-${type} ${selectedNumber != undefined ? 'selected' : ''}' data-number='${selectedNumber != undefined ? selectedNumber : ''}'><span class="lottery-number">${selectedNumber != undefined ? selectedNumber : ''}</span></p>`
            }).join('')
                    
            const customSelection = this.newNumbersArr(minNum, maxNum).map((number, index) => {
                const selectedIndex = numbers.indexOf(number)
                return `<p class='custom-selection ${selectedIndex > -1 ? 'selected' : ''}' data-number="${number}"><span class="lottery-number">${number}</span></p>`
            }).join('')

            var instructionText = "";
            if (type == 'number') {
                instructionText = `Choose ${count} main numbers`
            }
            else if (parseInt(count) == 1) {
                instructionText = `Choose your ${this.gameConfig.suppName}`
                if(this.isPrimitiva) 
                    instructionText = `Please choose a Reintegro number for the next 8 games`                
            }
            else {
                instructionText = `Choose your ${count} ${this.gameConfig.suppName}s`   
            }

            //check for reintegro logic
            return `<div class="custom-numbers custom-numbers--${type} ${this.isPrimitiva?'primitiva-custom-numbers':''}" data-gametype="${type}">
                        <p class="instruction-text">${instructionText}</p><p class="custom-numbers--title">${type == 'number' ? `<span class='quick-select'>${boltIcon}</span>` : ''} ${type == 'number' ? `<span class="lottery-reset" data-tooltip="Reset">${iconReset}</span><span class="remove-line lottery-close" data-tooltip="Delete">${iconClose}</span>` : ''}</p>
                        <div class="custom-numbers--selected">
                            ${customSelected}
                        </div>
                        <div class="custom-numbers--selection">
                            ${customSelection}
                        </div>
                    </div>`
        }

        customPlayHTML() {
            this.updateLinesCount()

            if(this.addGameButton != undefined) {
                this.addGameButton.classList.add('disabled')
            }

            var numbersHTML = this.customPlayHTMLBlock(this.selectedNumbers.main, this.gameConfig.minMain, this.gameConfig.maxMain, this.gameConfig.numMain, 'number')
            if (this.gameConfig.numSupp > 0) {
                numbersHTML = numbersHTML + this.customPlayHTMLBlock(this.selectedNumbers.supp, this.gameConfig.minSupp, this.gameConfig.maxSupp, this.gameConfig.numSupp, 'lucky')
            }

            return `<p class="game-count">Game ${this.linesCount}</p>
                <div class="game-numbers--container">
                    ${numbersHTML}
                    <div class="custom-numbers--action">
                        <button class="select-numbers button button-blue" type="button">Confirm</button>
                    </div>
                </div>`
        }

        customNumberSelection() {
            const customNumbersContainers = [...this.numberLine.querySelectorAll('.custom-numbers')]

            customNumbersContainers.map(customNumbersContainer => {
                const customSelections = [...customNumbersContainer.querySelectorAll('.custom-selection')]
                const customSelected = [...customNumbersContainer.querySelectorAll('.custom-selected')]
                // number or lucky (main/supp)
                const containerType = customNumbersContainer.dataset.gametype

                customSelections.map(customSelection => {
                    customSelection.onclick = () => {
                        if(this.quickSelectLock) return

                        const number = customSelection.dataset.number
                        const emptySelected = customNumbersContainer.querySelector('.custom-selected[data-number=""]')

                        if(!customSelection.classList.contains('selected') && emptySelected != null) {
                            emptySelected.classList.add('selected')
                            emptySelected.dataset.number = number
                            emptySelected.querySelector('.lottery-number').innerHTML = number
                        } else {
                            const selectedNumber = customNumbersContainer.querySelector(`.custom-selected[data-number="${number}"]`)
                            
                            if(selectedNumber == null) return

                            selectedNumber.classList.remove('selected')
                            selectedNumber.dataset.number = ''
                            selectedNumber.querySelector('.lottery-number').innerHTML = number
                        }

                        if (containerType == 'number') {
                            const mainIndex = this.selectedNumbers.main.indexOf(parseInt(number))
                            if (this.selectedNumbers.main[mainIndex] > -1) {
                                this.selectedNumbers.main[mainIndex] = undefined
                            } else {
                                this.selectedNumbers.main[this.selectedNumbers.main.indexOf(undefined)] = parseInt(number)
                            }
                        }
                        if (containerType == 'lucky') {
                            const suppIndex = this.selectedNumbers.supp.indexOf(parseInt(number))
                            if (this.selectedNumbers.supp[suppIndex] > -1) {
                                this.selectedNumbers.supp[suppIndex] = undefined
                            } else {
                                this.selectedNumbers.supp[this.selectedNumbers.supp.indexOf(undefined)] = parseInt(number)
                            }
                        }

                        customSelection.classList.toggle('selected')
                    }

                    customSelected.map(selected => {
                        selected.onclick = () => {
                            if(this.quickSelectLock) return

                            const selectedDataNumber = selected.dataset.number

                            if(selectedDataNumber) {
                                customNumbersContainer.querySelector(`.custom-selection[data-number="${selectedDataNumber}"]`).click()
                            }
                        }
                    })
                })
            })
            
            this.applySelectNumbers()
            this.cancelSelectNumbers()
        }

        applySelectNumbers() {
            this.selectNumbersButton = this.numberLine.querySelector('.select-numbers')
            this.selectNumbersButton.onclick = () => {
                const mainInvalid = this.selectedNumbers.main.indexOf(undefined) > -1;                
                const suppInvalid = this.isPrimitiva ? false : this.gameConfig.numSupp > 0 && this.selectedNumbers.supp.indexOf(undefined) > -1;
                //If Primitiva allow invalid supplement - as they dont choose it here
                if (mainInvalid || suppInvalid) {
                    createNotification("You haven't selected enough numbers.")
                }
                else {
                    if (this.selectCallback) {
                        // if selectCallback returns true, it means the page will be reloaded, therefore don't perform any further animations
                        if (this.selectCallback(this)) {
                            return
                        }
                    }
                    this.lineHTML()
                }
                this.scrollToGame()
            }
        }

        cancelSelectNumbers() {
            this.cancelNumbersButton = this.numberLine.querySelector('.lottery-reset')
            this.cancelNumbersButton.onclick = () => {
                 //reset current game to unselected
                [...this.numberLine.querySelectorAll('.custom-numbers')].map(customNumbers => {
                    const containerType = customNumbers.dataset.gametype
                    let notSelectedLength = [...customNumbers.querySelectorAll('.custom-selected:not(.selected)')].length
                    const selectedNumbers = [...customNumbers.querySelectorAll('.custom-selection.selected')]
                   
                    if (containerType == 'number') {
                        this.selectedNumbers.main.map((emptySelected, index) => {
                            this.selectedNumbers.main[index] = undefined
                        })
                    }
                    if (containerType == 'lucky') {
                        this.selectedNumbers.supp.map((emptySelected, index) => {
                            this.selectedNumbers.supp[index] = undefined
                        })
                    }

                    selectedNumbers.map(selectedNumber => {
                        selectedNumber.classList.remove('selected')
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"]`).classList.remove('selected')
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"] span`).innerHTML = ''
                        customNumbers.querySelector(`.custom-selected[data-number="${selectedNumber.dataset.number}"]`).dataset.number = ''
                    })
                    
                })
            }
        }

        adjustLineNumbers() {
            [...this.numberLines.querySelectorAll('.game-number-line')].map((numberLine, index) => {
                numberLine.querySelector('.game-count').innerHTML = `Game ${index + 1}`
            })
        }

        lineHTMLBlock(minNum, maxNum, count, type, numbersShuffle) {
            //check Guaranteed config
            const guaranteedMain = this.gameConfig.guaranteedMain;
            const guaranteedSupp = this.gameConfig.guaranteedSupp;

            if (numbersShuffle) {
                if (type === 'number') {
                    this.selectedNumbers.main = this.shuffleArray(this.newNumbersArr(minNum, maxNum), count);
                }
                else if (type === 'lucky') {
                    this.selectedNumbers.supp = this.shuffleArray(this.newNumbersArr(minNum, maxNum), count);
                }
            }

            var numbersLine = ''
            if (type == 'number') {
                numbersLine = this.selectedNumbers.main.map(number => {
                    return `<div class="lottery-number ${type}"><span><span>${number}</span></span></div>`
                }).join('')
            }
            else if (type == 'gmain') {
                for (let i of this.gameConfig.guaranteedMain) {
                    numbersLine = numbersLine + `<div class="lottery-number" id="guaranteed-power-main"><span><span>G</span></span></div>`;                  
                }
            }  
            else if (type == 'lucky') {
                numbersLine = this.selectedNumbers.supp.map(number => {
                    return `<div class="lottery-number ${type} ${this.isPrimitiva?'primitiva-lucky':''}"><span><span>${number}</span></span></div>`
                }).join('')
            }
            else if (type == 'gsupp') {
                for (let i of this.gameConfig.guaranteedSupp) {
                    numbersLine = numbersLine + `<div class="lottery-number" id="guaranteed-power-g"><span><span>G</span></span></div>`;                  
                }
            }
 
 
            return `<div class="lottery-numbers edit-line">${numbersLine}</div>`             
        }

        lineHTML(numbersShuffle = false) {
            this.updateLinesCount()
            const editIcon = `<svg width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg"><g transform="translate(1 .5)" fill-rule="nonzero" fill="none" opacity=".2"><circle stroke="#000" stroke-width=".8" cx="7.5" cy="7.5" r="7.5"/><path d="M11.904 4.65L10.33 3.09a.34.34 0 00-.463 0L4.146 8.75a.321.321 0 00-.091.18l-.301 1.947a.321.321 0 00.098.284.33.33 0 00.293.082l1.876-.39a.33.33 0 00.164-.088l5.72-5.658a.322.322 0 000-.458zm-5.28 4.764l-1.111-1.1 3.304-3.268 1.111 1.1-3.304 3.268zm-.834.826l-1.318.273.213-1.38.364-.36 1.112 1.1-.37.367zm4.601-4.552l-1.111-1.1.818-.81 1.111 1.1-.818.81z" fill="#000"/></g></svg>`
            var numberLineNumbers = this.lineHTMLBlock(this.gameConfig.minMain, this.gameConfig.maxMain, this.gameConfig.numMain, 'number', numbersShuffle)
            // add orange G label if game has Guaranteed main
            if (this.gameConfig.guaranteedMain > 0) {
                numberLineNumbers += this.lineHTMLBlock(this.gameConfig.minSupp, this.gameConfig.maxSupp, this.gameConfig.numSupp, 'gmain')
            }

            if (this.gameConfig.numSupp > 0) {
                numberLineNumbers += this.lineHTMLBlock(this.gameConfig.minSupp, this.gameConfig.maxSupp, this.gameConfig.numSupp, 'lucky', numbersShuffle)
            }

            // add G label if game has Guaranteed supp
            if (this.gameConfig.guaranteedSupp > 0) {
                numberLineNumbers += this.lineHTMLBlock(this.gameConfig.minSupp, this.gameConfig.maxSupp, this.gameConfig.numSupp, 'gsupp')               
            }

            let lineActions = "";
            if (this.gameConfig.showLineActions) {
                lineActions = `<div class="lottery-line-actions"><img class="edit-line lottery-edit" src="/assets/icons/editIcon.svg" title="edit" width="15" height="15"/><img class="remove-line lottery-close" src="/assets/icons/delicon.svg" title="delete" width="15" height="15"/></div>`
            }

            this.numberLine.innerHTML = `${typeof this.linesCount === 'number' && this.linesCount >= 0 ? `<div class="flex"><p class="game-count">Game ${this.linesCount}</p></div>` : ''}
                <div class="number-line--numbers flex" id="game-id-${this.selectedNumbers.id}">
                    <div class="lottery-numbers-container">
                        ${numberLineNumbers}
                    </div>
                    ${lineActions}
                    <input type="hidden" name="gameData" value='${JSON.stringify(this.selectedNumbers)}'>
                </div>`

            this.configureRemoveGameEvent()
            //this.selectFavourite()
            this.editGame()

            if(this.addGameButton != undefined) {
                this.gameCost()

                const openGame = this.numberLines.querySelector('.game-numbers--container')
                
                if(!openGame) {
                    this.addGameButton.classList.remove('disabled')
                }
            }            
        }

        scrollToGame(el = this.numberLine) {
            let container = window

            const navTab = utility.findAncestor(el, 'nav-tab')

            if(navTab) {
                container = navTab
            }

            container.scrollBy({top: el.getBoundingClientRect().top - document.querySelector('#header').offsetHeight - 10, left: 0, behavior: 'smooth' });
        }

        newNumbersArr(min, max) {
            var numbersArr = [];
            var n = min
            while (n <= max) {
                numbersArr.push(n++)
            }
            return numbersArr
        }

        shuffleArray(arr, count) {
            for (let i = arr.length - 1; i > 0; i--) {
                const n = Math.floor(Math.random() * (i + 1));
                const temp = arr[i];
                arr[i] = arr[n];
                arr[n] = temp;
            }
            return arr.splice(0, count);
        }
    }
}

export default lotteryGame


// WEBPACK FOOTER //
// ./assets/src/js/classes/lotteryGame.js